



































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Accordion extends Vue {
    @Prop({ type: String }) header!: string;
    @Prop({ type: String, default: 'div' }) tag!: string;
    @Prop({ type: String, default: 'div' }) bodyTag!: string;
    @Prop({ type: Boolean, default: false }) hideIcon!: boolean;
    @Prop({ type: Boolean, default: true }) multiple!: boolean;
    @Prop({ type: Boolean, default: false }) disabled!: boolean;
    @Prop({ type: Boolean, default: false }) expanded!: boolean;
    @Prop({ type: Boolean, default: false }) hideHeader!: boolean;
    @Prop({ type: Boolean, default: false }) keepAlive!: boolean;
	@Prop({ type: Boolean, default: false }) transparent!: boolean;

	isExpanded: boolean = false;

	created() {
	    this.isExpanded = this.expanded;
	}

	public close() {
	    this.isExpanded = false;
	}

	public open(): void {
	    this.isExpanded = true;
	}

	toggle(e: any) {
	    if (this.disabled) return;
	    this.isExpanded = !this.isExpanded;
	    if (this.multiple) return;

	    // Close the rest
	    this.$parent!.$children.forEach(child => {
	        if (child instanceof Accordion && child !== this) {
	            child.isExpanded = false;
	        }
	    });
	}

	get style(): string {
	    return this.transparent ? 'background: transparent; padding: 0; border: none;' : '';
	}

	setFixedHeight(el: HTMLElement) {
	    el.style.height = el.scrollHeight + 'px';
	}

	setAutoHeight(el: HTMLElement) {
	    el.style.height = 'auto';
	}
}
